import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          最新动态
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          平台影视内容与功能更新快讯
        </p>
        <div className="relative pl-8 border-l-2 border-background-200">
          {updates.map((item, index) => (
            <div
              key={item.id}
              className={`relative pb-8 ${index === updates.length - 1 ? 'pb-0' : ''}`}
            >
              <div className="absolute -left-[calc(2rem+5px)] top-0.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <p className="text-sm text-foreground-800 font-medium">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}